module.exports = __webpack_public_path__ + "img/GB-SCT.c3295dd0.png";